<template>
  <div class="free-shipping-progress-bar__wrapper">
    <div v-if="is_visible" class="free-shipping-progress-bar">
      <div v-if="current_amount > 0" class="container">
        <div class="columns is-gapless">
          <div class="column is-6 has-text-centered">
            <h1 class="title is-6 text-color mb-1">
              Agrega
              <span class="contrast-color">{{
                remaining_amount | currency
              }}</span>
              <span class="is-hidden-mobile">a tu carrito</span> y obtén envío
              gratis.
            </h1>
          </div>
          <div class="column is-6 has-text-centered">
            <div class="columns">
              <div class="column is-8">
                <div class="pl-3 pr-3">
                  <b-progress
                    type="is-success"
                    size="medium"
                    :max="100"
                    :value="current_percent"
                    :show-value="true"
                    format="percent"
                    :precision="2"
                    :keep-trailing-zeroes="true"
                    locale="es-MX"
                  ></b-progress>
                </div>
              </div>
              <div class="column is-4 is-hidden-mobile">
                {{ current_amount | currency }} / {{ target_amount | currency }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="container">
        <div class="mt-3 is-hidden-tablet"></div>
        <h1 class="title is-6 text-color mb-1 has-text-centered">
          Agrega
          <span class="contrast-color">{{ target_amount | currency }}</span>
          <span class="is-hidden-mobile">a tu carrito</span> y obtén envío
          gratis.
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
import AppMappers from "@/store/app-global-mappers";

export default {
  name: "FreeShippingProgressBar",
  mixins: [AppMappers],
  props: ["default_target_amount"],
  data() {
    return {
      has_free_shipping: false,
      target_amount: 100,
      current_amount: 0,
    };
  },
  computed: {
    is_visible() {
      if (this.current_amount >= this.target_amount) {
        return false;
      }

      if (this.cart_step !== "cart") {
        return false;
      }

      return true;
    },
    current_percent() {
      if (this.current_amount > 0) {
        return (
          Math.round((this.current_amount / this.target_amount) * 100 * 1e2) /
          1e2
        );
      }

      // Avoid div by zero
      return 0;
    },
    remaining_amount() {
      return this.target_amount - this.current_amount;
    },
  },
  created() {
    if (this.default_target_amount) {
      this.target_amount = this.default_target_amount;
    }
  },
  mounted() {
    //console.log("Received data", this.product)
  },
  methods: {},
  watch: {
    // From computed Vuex Store getters
    cart_status() {
      this.current_amount = this.order_subtotal;
      if (this.store_shipping_details) {
        this.has_free_shipping = this.store_shipping_details.has_free_shipping;

        if (
          (this.target_amount =
            this.store_shipping_details.free_shipping_required_amount > 0)
        ) {
          this.target_amount =
            this.store_shipping_details.free_shipping_required_amount;
        } else {
          if (this.default_target_amount) {
            this.target_amount = this.default_target_amount;
          }
        }
      } else {
        if (this.default_target_amount) {
          this.target_amount = this.default_target_amount;
        }
      }

      // console.log("Current amount", this.current_amount);
      // console.log("Target amount", this.target_amount);
      // console.log("Is visible", this.is_visible);
    },
  },
};
</script>

<style lang="scss">
$background: #444;
$text: #48c774;
$contrast: #ffffff;

.free-shipping-progress-bar {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 40px;
  padding: 12px 0;
  background-color: $background;
  color: $text;
  z-index: 10000;

  .text-color {
    color: $text;
  }

  .contrast-color {
    color: $contrast;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .free-shipping-progress-bar {
    height: 65px;
    // top: 78px !important;
    z-index: 100 !important;
  }
}
</style>